<template>
  <div id="fileViewer">
    <ElImageViewer
      v-if="showPreViewImage && fileList.length > 0"
      :on-close="closeViewer"
      :z-index="3000"
      :url-list="fileList.map(item => item.url)"
      hide-on-click-modal
    />
    <div v-if="showPreViewPdf" class="pdf-previewer">
      <div class="close-preview-btn" @click="closePDFViewer">
        <i class="el-icon-circle-close"></i>
      </div>
      <div class="app-content">
        <!-- <vue-pdf-embed ref="pdfRef" :source="pdfSource" :page="page" @loaded="handleDocumentLoad" /> -->
      </div>
      <div class="app-button">
        <el-button :disabled="page <= 1" @click="page--">❮</el-button>
        <span>{{ page }} / {{ pageCount }}</span>
        <el-button :disabled="page >= pageCount" @click="page++">❯</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
// import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js';
export default {
  name: 'FileViewer',
  components: {
    ElImageViewer
    // VuePdfEmbed
  },
  props: ['showFileViewer', 'file'],
  data() {
    return {
      showPreViewImage: false,
      showPreViewPdf: false,
      fileList: [],
      pdfSource: '',
      page: 1,
      pageCount: null
    };
  },
  methods: {
    handleDocumentLoad({ numPages }) {
      this.pageCount = numPages;
    },
    init(file) {
      const type = file.type || file.raw.type;
      if (type.endsWith('pdf')) {
        this.pdfSource = file.source;
        this.showPreViewPdf = true;
      } else {
        this.fileList.push(file);
        this.showPreViewImage = true;
      }
    },
    closeViewer() {
      this.showPreViewImage = false;
      this.$emit('update:showFileViewer', false);
    },
    closePDFViewer() {
      this.showPreViewPdf = false;
      this.$emit('update:showFileViewer', false);
    }
  },
  mounted() {
    this.init(this.file);
  }
};
</script>
<style lang="scss" scoped>
.pdf-previewer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 9999;
  .close-preview-btn {
    position: absolute;
    align-self: flex-end;
    cursor: pointer;
    z-index: 1000;
    top: 20px;
    right: 16px;
    width: 28px;
    height: 28px;
    font-size: 28px;
    > i {
      color: #fff;
      border-radius: 50%;
      background-color: #606266;
    }
  }

  .vue-pdf-embed > div {
    margin-bottom: 8px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
  }

  .app-button {
    padding: 16px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
    background-color: #555;
    color: #ddd;
    span {
      margin: 0 10px;
    }
  }

  .app-content {
    padding: 24px 16px;
    width: 600px;
  }

  .right {
    float: right;
  }
}
@media (max-width: 768px) {
  .pdf-previewer {
    .app-content {
      width: auto;
    }
  }
}
</style>
